import axios from "axios";

export function assertBackendHelperEnv() {
  const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
  const apiKey = process.env.REACT_APP_BACKEND_API_KEY;
  if (!baseUrl || !apiKey) {
    throw new Error(
      "Missing REACT_APP_BACKEND_BASE_URL or REACT_APP_BACKEND_API_KEY"
    );
  }
  return { baseUrl, apiKey };
}

/**
 * POST `{REACT_APP_BACKEND_BASE_URL}/helper` — shared backend AI helper used across the app.
 *
 * @param {object} params
 * @param {string} params.prompt - System / instruction prompt
 * @param {string|object|Array} params.message - Request body `message`
 * @param {string} [params.llmProvider] - Backend routing: "openai" (defaults to Eden)
 * @returns {Promise<object>} Successful API body (`{ success: true, data: { content, ... }, ... }`)
 */
export async function postBackendHelper({
  prompt,
  message,
  llmProvider,
}) {
  const { baseUrl, apiKey } = assertBackendHelperEnv();
  const body = { prompt, message };
  if (llmProvider) body.llmProvider = llmProvider;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiKey}`,
  };

  const res = await axios.post(`${baseUrl}/helper`, body, { headers });

  const data = res.data;
  if (!data?.success) {
    throw new Error(data?.error || data?.message || "Helper failed");
  }
  return data;
}

/** Same as {@link postBackendHelper} but returns `data.data.content` only. */
export async function postBackendHelperContent(params) {
  const data = await postBackendHelper(params);
  return data?.data?.content;
}
